import { PendingInvitesProvider } from './context/PendingInvitesProvider'
import { PendingInvitesMain } from './components/PendingInvitesMain'

export function PendingInvites() {
  return (
    <PendingInvitesProvider>
      <PendingInvitesMain />
    </PendingInvitesProvider>
  )
}
